import debounce from '@wwdev/functions/debounce.js';

class Basket {
	constructor() {
		this.setupListeners();
	}

	setupListeners() {
		$("div.winkelwagen-wrapper").off('change').on('change', 'input.amount', debounce(this.updateQuantity.bind(this), 250));
	}

	updateQuantity(e) {
		if (jQuery(e.currentTarget).parents('.shop-cart_item_materials').length == 0) {
			if (jQuery(e.currentTarget).val() * 1.0 <= 0) {
				if ( confirm(window.removeMessage) ) {
					jQuery.post('', {
						action : 'remove_product',
						productId : jQuery(e.currentTarget).attr('name')
					}, this.draw.bind(this));
					return false;
				} else {
					jQuery(e.currentTarget).val(1).trigger('change');
					return false;
				}
			}
		}
		
		window.showLoader();

		jQuery.post('', {
			action : 'update_product_quantity',
			lineItem : jQuery(e.currentTarget).attr('name'),
			amount:  jQuery(e.currentTarget).val() * 1.0,
		}, this.draw.bind(this));
	}

	draw(response) {
		window.hideLoader();
		$("div.winkelwagen-wrapper").html(jQuery(response.winkelwagen_html).first().html());
		$("div.winkelwagen-indicator-wrapper").html(jQuery(response.indicator_html).first().html());
	}
}

export default Basket;